"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandardEvents = void 0;
const js_event_bus_1 = __importDefault(require("js-event-bus"));
exports.StandardEvents = {
    ChangeLanguage: 'CHANGE_LANGUAGE',
    ChangePassword: 'CHANGE_PASSWORD',
    Login: 'LOGIN',
    Logout: 'LOGOUT',
    SelectedOrganisation: 'SELECTED_ORGANISATION',
    SetAppHeaderState: 'SET_APP_HEADER_STATE',
    SetRecentDevice: 'SET_RECENT_DEVICE',
    SetRecentDomesticDevice: 'SET_RECENT_DOMESTIC_DEVICE',
    SetRecentSite: 'SET_RECENT_SITE',
    SetSidebarState: 'SET_SIDEBAR_STATE',
    SetAiModalState: 'SET_AI_MODAL_STATE',
    SetUserPreferences: 'SET_USER_PREFERENCES',
    SetDevToolsModalState: 'SET_DEV_TOOLS_MODAL_STATE',
};
class ApplicationEventBus {
    constructor() {
        this.eventBus = new js_event_bus_1.default();
        this.cache = {};
    }
    clearCache() {
        this.cache = {};
    }
    detach(eventType, callback) {
        this.eventBus.detach(eventType, callback);
    }
    emit(eventType, ...args) {
        this.cache[eventType] = args;
        this.eventBus.emit(eventType, null, ...args);
    }
    on(eventType, callback) {
        this.eventBus.on(eventType, callback);
        if (this.cache[eventType]) {
            callback(...this.cache[eventType]);
        }
    }
}
exports.default = ApplicationEventBus;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZXZlbnQtYnVzL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLGdFQUFvQztBQUl2QixRQUFBLGNBQWMsR0FBRztJQUM1QixjQUFjLEVBQUUsaUJBQWlCO0lBQ2pDLGNBQWMsRUFBRSxpQkFBaUI7SUFDakMsS0FBSyxFQUFFLE9BQU87SUFDZCxNQUFNLEVBQUUsUUFBUTtJQUNoQixvQkFBb0IsRUFBRSx1QkFBdUI7SUFDN0MsaUJBQWlCLEVBQUUsc0JBQXNCO0lBQ3pDLGVBQWUsRUFBRSxtQkFBbUI7SUFDcEMsdUJBQXVCLEVBQUUsNEJBQTRCO0lBQ3JELGFBQWEsRUFBRSxpQkFBaUI7SUFDaEMsZUFBZSxFQUFFLG1CQUFtQjtJQUNwQyxlQUFlLEVBQUUsb0JBQW9CO0lBQ3JDLGtCQUFrQixFQUFFLHNCQUFzQjtJQUMxQyxxQkFBcUIsRUFBRSwyQkFBMkI7Q0FDbkQsQ0FBQztBQUVGLE1BQXFCLG1CQUFtQjtJQUF4QztRQUNtQixhQUFRLEdBQUcsSUFBSSxzQkFBUSxFQUFFLENBQUM7UUFFbkMsVUFBSyxHQUE2QixFQUFFLENBQUM7SUFxQi9DLENBQUM7SUFuQkMsVUFBVTtRQUNSLElBQUksQ0FBQyxLQUFLLEdBQUcsRUFBRSxDQUFDO0lBQ2xCLENBQUM7SUFFRCxNQUFNLENBQUMsU0FBaUIsRUFBRSxRQUF1QjtRQUMvQyxJQUFJLENBQUMsUUFBUSxDQUFDLE1BQU0sQ0FBQyxTQUFTLEVBQUUsUUFBUSxDQUFDLENBQUM7SUFDNUMsQ0FBQztJQUVELElBQUksQ0FBQyxTQUFpQixFQUFFLEdBQUcsSUFBVztRQUNwQyxJQUFJLENBQUMsS0FBSyxDQUFDLFNBQVMsQ0FBQyxHQUFHLElBQUksQ0FBQztRQUM3QixJQUFJLENBQUMsUUFBUSxDQUFDLElBQUksQ0FBQyxTQUFTLEVBQUUsSUFBSSxFQUFFLEdBQUcsSUFBSSxDQUFDLENBQUM7SUFDL0MsQ0FBQztJQUVELEVBQUUsQ0FBQyxTQUFpQixFQUFFLFFBQXVCO1FBQzNDLElBQUksQ0FBQyxRQUFRLENBQUMsRUFBRSxDQUFDLFNBQVMsRUFBRSxRQUFRLENBQUMsQ0FBQztRQUN0QyxJQUFJLElBQUksQ0FBQyxLQUFLLENBQUMsU0FBUyxDQUFDLEVBQUUsQ0FBQztZQUMxQixRQUFRLENBQUMsR0FBRyxJQUFJLENBQUMsS0FBSyxDQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUM7UUFDckMsQ0FBQztJQUNILENBQUM7Q0FDRjtBQXhCRCxzQ0F3QkMifQ==